import { render, staticRenderFns } from "./CNavBlock.vue?vue&type=template&id=01e686bc&"
import script from "./CNavBlock.vue?vue&type=script&lang=ts&"
export * from "./CNavBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports